export default __webpack_public_path__ + "9a61a67c7d95a6c2c86f824c5fca5e2e.png";